export class ResourceVO {
    
    affinityId: Number;
    affinityName: String;
    productId: Number;
    productName: String;

   
}
